import { Injectable } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { IRanchWellViewModel } from '../../ranch-settings/interfaces';

@Injectable()
export class NContributionUpdateService {

	private _cancelled: Subject<void>;
	private _loaded: Subject<void>;
	private _submitted: Subject<void>;
	// N contribution dialog: user continued from wells UI with a wells list to save.
	private _wellsContinue: Subject<IRanchWellViewModel[]>;
	// N contribution dialog: wells were saved and N contribution data is ready to show.
	private _wellsComplete: Subject<void>;
	// True when N contribution was opened with zero wells, so wells UI should show first.
	private _needsWells = false;
	// Local wells form used by the wells UI phase.
	private _wellsForm: FormArray = null;

	public cancelled$: Observable<void>;
	public loaded$: Observable<void>;
	public submitted$: Observable<void>;
	public wellsContinue$: Observable<IRanchWellViewModel[]>;
	public wellsComplete$: Observable<void>;

	constructor() {

		this._cancelled = new Subject<void>();
		this.cancelled$ = this._cancelled.asObservable();

		this._loaded = new Subject<void>();
		this.loaded$ = this._loaded.asObservable();

		this._submitted = new Subject<void>();
		this.submitted$ = this._submitted.asObservable();

		this._wellsContinue = new Subject<IRanchWellViewModel[]>();
		this.wellsContinue$ = this._wellsContinue.asObservable();

		this._wellsComplete = new Subject<void>();
		this.wellsComplete$ = this._wellsComplete.asObservable();
	}

	public get needsWells(): boolean {
		return this._needsWells;
	}

	public get wellsForm(): FormArray {
		return this._wellsForm;
	}

	// Store wells UI state for the desktop N contribution dialog open handoff.
	public setWellsState(needsWells: boolean, form: FormArray): void {
		this._needsWells = needsWells;
		this._wellsForm = form;
	}

	public clearWellsState(): void {
		this._needsWells = false;
		this._wellsForm = null;
	}

	public triggerLoaded() {
		this._loaded.next(); // data for the form is loaded. Happens before the form is displayed
	}

	public triggerCancelled() {
		this._cancelled.next();
	}

	public triggerSubmitted() {
		this._submitted.next();
	}

	public triggerWellsContinue(wells: IRanchWellViewModel[]) {
		this._wellsContinue.next(wells);
	}

	public triggerWellsComplete() {
		this._wellsComplete.next();
	}
}
